var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.917 35.4163H14.5837C11.7017 35.4163 9.24512 34.4007 7.21387 32.3695C5.18262 30.3382 4.16699 27.8816 4.16699 24.9997C4.16699 22.1177 5.18262 19.6611 7.21387 17.6299C9.24512 15.5986 11.7017 14.583 14.5837 14.583H22.917V18.7497H14.5837C12.8475 18.7497 11.3719 19.3573 10.1566 20.5726C8.9413 21.7879 8.33366 23.2636 8.33366 24.9997C8.33366 26.7358 8.9413 28.2115 10.1566 29.4268C11.3719 30.642 12.8475 31.2497 14.5837 31.2497H22.917V35.4163ZM16.667 27.083V22.9163H33.3337V27.083H16.667ZM27.0837 35.4163V31.2497H35.417C37.1531 31.2497 38.6288 30.642 39.8441 29.4268C41.0594 28.2115 41.667 26.7358 41.667 24.9997C41.667 23.2636 41.0594 21.7879 39.8441 20.5726C38.6288 19.3573 37.1531 18.7497 35.417 18.7497H27.0837V14.583H35.417C38.2989 14.583 40.7555 15.5986 42.7868 17.6299C44.818 19.6611 45.8337 22.1177 45.8337 24.9997C45.8337 27.8816 44.818 30.3382 42.7868 32.3695C40.7555 34.4007 38.2989 35.4163 35.417 35.4163H27.0837Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.cbc4141163063f7e3cc9af9d7267fc29.svg";
export { ForwardRef as ReactComponent };